module.exports = __webpack_public_path__ + "074ffec17ffcca73a241062727dc6a42.jpg";